import { useCallback } from 'react';
var useCallbackOnce = function (callback) { return useCallback(callback, []); };
export default useCallbackOnce;
//# sourceMappingURL=useCallbackOnce.js.map